<script setup lang="ts">
import { PropType, computed, ref } from "vue";
import { useStoryBook } from "@/stores/story-book";
import StoryListItem from "@/components/mobile/story/story-chapter/StoryListItem.vue";
import { storeToRefs } from "pinia";
import { watch } from "vue";
import { StoryBook } from "@/types/entity";
// Props & Emit
const props = defineProps({
  show: Boolean,
  exclude: Array as PropType<number[]>,
});

const emit = defineEmits(["update:show", "selected"]);

// State
const selectedStoryBook = ref<StoryBook | null>(null);
const store = useStoryBook();

const { allStoryBookList } = storeToRefs(store);

const storyBookList = computed<StoryBook[]>(() =>
  allStoryBookList.value.filter(
    (item) =>
      item.description && !props.exclude?.includes(item.id!) && item.dtPublish
  )
);

const clickStoryBook = async (id: number) => {
  selectedStoryBook.value = storyBookList.value.find((item) => item.id === id)!;
};

const clickClose = () => {
  emit("update:show", false);
};

// Lifecycle

// EventHandler
const clickConfirm = async () => {
  emit("update:show", false);
  emit("selected", selectedStoryBook.value);
};

const loading = ref(false);
watch(
  () => props.show,
  async (val) => {
    if (val) {
      loading.value = true;
      await store.getStoryBookList(true);
      loading.value = false;
    }
  }
);
</script>
<template>
  <VanPopup
    position="bottom"
    class="max-h-[80%] overflow-hidden grid grid-rows-[auto_1fr]"
    :show="show"
    @update:show="emit('update:show', $event)"
    round
    teleport="body"
  >
    <div class="navbar h-top-nav border-b">
      <!-- 左 -->
      <div class="navbar-start h-full">
        <button class="btn btn-sm rounded" @click="clickClose">
          {{ $t("Buttons.cancel") }}
        </button>
      </div>
      <!-- 中 -->
      <div class="navbar-center">
        <div class="font-bold">
          {{ $t("Texts.chooseStory") }}
        </div>
      </div>
      <!-- 右 -->
      <div class="navbar-end">
        <button
          class="btn btn-primary btn-sm rounded"
          :disabled="selectedStoryBook === null"
          @click="clickConfirm"
        >
          {{ $t("Buttons.confirm") }}
        </button>
      </div>
    </div>
    <div class="w-full overflow-hidden flex flex-col relative">
      <div class="overflow-y-auto w-full h-full" ref="scrollableEl">
        <div v-show="loading" class="h-40 flex items-center justify-center">
          <span class="loading"></span>
        </div>
        <div
          v-show="!loading && storyBookList.length === 0"
          class="h-40 flex flex-col items-center justify-center"
        >
          <div class="text-2xl font-bold text-base-content/50">
            {{ $t("Message.noStoriesPublishedYet") }}
          </div>
          <div class="text-base-content/50">
            {{ $t("Message.noStoriesPublishedYetDesc") }}
          </div>
        </div>
        <div v-show="!loading && storyBookList.length > 0" class="p-2 pt-0">
          <div
            v-for="item in storyBookList"
            :key="item.id"
            class="relative"
            :class="{
              'border-primary border rounded':
                selectedStoryBook?.id === item.id,
              'border border-transparent ': selectedStoryBook?.id !== item.id,
            }"
            @click="clickStoryBook(item.id!)"
          >
            <story-list-item class="px-2" :story="item" />
            <check-circle-fill-icon
              v-show="selectedStoryBook?.id === item.id"
              class="text-primary absolute right-1 bottom-1 icon-xl rounded-full"
            />
          </div>
        </div>
      </div>
    </div>
  </VanPopup>
</template>
